import { useState, useEffect } from "react";
import { _get } from "../services/service_api";
import { API_BASE_URL, directToken, Roles_list } from "../services/end_points";
export const useRoleData = ({ handleRole }) => {
  const [data, setData] = useState([]);
  const column = [];
  const rows = data.map((user, index) => ({
    key: index + 1,
    id: user.id,
    userType: user.userType,
    city: user.city,
    location: user.location,
    hospital: user.hospital,
    speciality: user.speciality,
    doctor: user.doctor,
    roleManagement: user.roleManagement,
    userManagement: user.userManagement,
    dataManagement: user.dataManagement,
    dashbord: user.dashbord,
    appointment: user.appointment,
    assignSpeciality: user.assignSpeciality,
    edit: user.edit,
    delete: user.delete,
    createdAt: user.createdAt,
  }));

  useEffect(() => {
    const getRoledata = async () => {
      try {
        const userId = localStorage.getItem("userid");
        const response = await _get(
          `${API_BASE_URL}${Roles_list}${userId}`,
          directToken
        );
        setData(response.data.list);
      } catch (error) {
        console.error(error);
      }
    };

    getRoledata();
  }, []); // Runs once after the first render

  return { column, rows };
};
